(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('hyperapp')) :
	typeof define === 'function' && define.amd ? define(['exports', 'hyperapp'], factory) :
	(factory((global.context = {}),global.hyperapp));
}(this, (function (exports,hyperapp) { 'use strict';

function resolveNode (node, context) {
    context = context || {};
    if (node == null) return node
    if (typeof node === 'function') {
        return resolveNode(
            node(
                context,
                function (props) {
                    context = Object.assign({}, context, props);
                }
            ),
            context
        )
    }
    if (Array.isArray(node)) {
        node = node.map(function (n) { return resolveNode(n, context)});
        node = Array.prototype.concat.apply([], node);
        node = node.filter(function (n) { return n != null });
        return node
    }
    if (!node.attributes) return node
    return {
        nodeName: node.nodeName,
        attributes: Object.assign({}, node.attributes),
        children: resolveNode(node.children, context)
    }
}

function treeProcessor (processor) {
    return function (props, children) {
        return function (context) {
            return processor(props, resolveNode(children), context)
        }
    }
}

function decorator (getDecoration) {
    return treeProcessor(function (props, children, context){
        var decoration = getDecoration(props, context);
        return children.map(function (child) {
            if (!child.attributes) return child
            Object.keys(decoration).forEach(function (name) {
                if (name === 'class') {
                    var oc = child.attributes.class;
                    var dc = decoration.class;
                    child.attributes.class = (oc ? oc + ' ' : '') + (dc ? dc : '');
                } else if (name.substr(0, 2) === 'on') {
                    var oh = child.attributes[name];
                    var dh = decoration[name];
                    child.attributes[name] = !oh ? dh : function (a,b) {oh(a, b); dh(a, b);};
                } else {
                    child.attributes[name] = decoration[name];
                }
            });
            return child            
        })
    })
}

function nestable (state, actions, view, tagname) {
    actions._$r = function () {return {}};
    return function (props, children) {
        return function (context) {
            return hyperapp.h(tagname || 'x-', {
                key: props.key,
                id: props.id,
                class: props.class,
                oncreate: function (el) {
                    el._$p = props;
                    el._$c = children;
                    el._$x = context;
                    var wired = hyperapp.app(
                        state,
                        actions,
                        function (s, a) {
                            var node = view(s, a);
                            if (typeof node === 'function') node = node(el._$p,  el._$c);
                            node = resolveNode(node, el._$x);
                            return (node && node.length) ? node[0] : node
                       },
                       el
                    );
                    el._$r = wired._$r;
                    el._$u = wired.uninit;
                    wired.init && wired.init(props);
                    props.oncreate && props.oncreate(el);
                },
                onupdate: function (el) {
                    el._$p = props;
                    el._$c = children;
                    el._$x = context;
                    el._$r();
                    props.onupdate && props.onupdate(el);
                },
                ondestroy: function (el) {
                    el._$u && el._$u();
                    props.ondestroy && props.ondestroy(el);
                },
                onremove: function (el, done) {
                   if (!props.onremove) return done()
    
                   props.onremove(el, done);
                }
            })            
        }
    }
}

function _with (app$$1) {
    return function (initialState, actionDefinitions, originalView, container) {
        var view = function (state, actions) {
            var node = resolveNode(originalView(state, actions));
            return node && (node.length ? node[0] : node)
        };
        return app$$1(initialState, actionDefinitions, view, container)
    }
}

exports.withContext = _with;
exports.processor = treeProcessor;
exports.decorator = decorator;
exports.nestable = nestable;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=hyperapp-context.js.map
